/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import moment from "moment-timezone";
import { Row, Col, Card } from "react-bootstrap";

export interface IFooterSectionProps {
    name: string;
    link: string;
}

export interface IFooterProps {
    copyrightStartYear: string;
    orgName: string;
    orgUrl: string;
    footerSections: IFooterSectionProps[];
}

export const Footer = (props: IFooterProps) => {
    const currentYear = moment().get("year");
    return (
        <div>
            <footer className="bg-white rounded shadow p-5 mb-4 mt-4">
                <Row>
                    <Col xs={12} md={4} xl={6} className="mb-4 mb-md-0">
                        <p className="mb-0 text-center text-lg-start">
                            © {`${props.copyrightStartYear}`}-
                            {`${currentYear} `}
                            <Card.Link
                                href={props.orgUrl}
                                target="_blank"
                                className="text-primary fw-normal"
                            >
                                {props.orgName}
                            </Card.Link>
                        </p>
                    </Col>
                    <Col
                        xs={12}
                        md={8}
                        xl={6}
                        className="text-center text-lg-start"
                    >
                        <ul className="list-inline list-group-flush list-group-borderless text-md-end mb-0">
                            {props.footerSections?.map((footer, index) => (
                                <li
                                    className="list-inline-item px-0 px-sm-2"
                                    key={`footer-section-${index}`}
                                >
                                    <Card.Link
                                        href={footer?.link}
                                        target="_blank"
                                    >
                                        {footer?.name}
                                    </Card.Link>
                                </li>
                            ))}
                        </ul>
                    </Col>
                </Row>
            </footer>
        </div>
    );
};

Footer.defaultProps = {};
